import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { selectAuth } from "store/slices/user.store";

export const IndexPage: FC = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAppSelector(selectAuth);

  useEffect(() => {
    if (isLoggedIn) navigate("/jobs", { replace: true });
    else navigate("/login", { replace: true });
  }, [isLoggedIn, navigate]);

  return null;
};
